package fr.frux.shared.dto

import kotlinx.serialization.Serializable

/** Plateforme déclarée par le client : elle décide de la variante, pas de l'éligibilité. */
@Serializable
enum class SupportPlatform { WEB, ANDROID, IOS, DESKTOP }

/** Ce que l'utilisateur vient de faire. Sert uniquement à écrire la phrase de contexte. */
@Serializable
enum class SupportPromptReason { CONTRIBUTION, HARVEST }

/**
 * `INLINE` : paliers et boutons de paiement dans la feuille (web uniquement).
 * `LINK_OUT` : un seul bouton sans montant qui ouvre la page de soutien (builds store).
 */
@Serializable
enum class SupportPromptVariant { INLINE, LINK_OUT }

@Serializable
data class SupportPromptResponse(
    val show: Boolean,
    val reason: SupportPromptReason? = null,
    val variant: SupportPromptVariant = SupportPromptVariant.LINK_OUT,
    val donateUrl: String? = null,
)

/**
 * Réponse de la route de don hors prompt (#319) : un don initié depuis le profil doit se
 * rattacher au compte au même titre qu'un don proposé dans le prompt, donc l'URL porte le même
 * jeton signé quand la cagnotte est active.
 */
@Serializable
data class SupportDonateUrlResponse(
    val donateUrl: String,
)
